import { Zap, BadgeCheck, FileCheck2, Headset } from "lucide-react";
import { Link } from "react-router-dom";
import { useContent } from "../contexts/ContentContext";
import { BrandLogo } from "./Header";

export default function Footer() {
  const { t } = useContent();
  const year = new Date().getFullYear();

  const trust = [
    { Icon: Zap, label: t("footer.trust1", "Mise en relation rapide") },
    { Icon: BadgeCheck, label: t("footer.trust2", "Profils vérifiés") },
    { Icon: FileCheck2, label: t("footer.trust3", "Contrats sécurisés") },
    { Icon: Headset, label: t("footer.trust4", "Support réactif") },
  ];

  return (
    <footer className="mt-24 bg-foreground text-background" data-testid="footer">
      {/* Barre de confiance */}
      <div className="border-b border-white/10">
        <div className="container-mc py-6 grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="footer-trust-bar">
          {trust.map(({ Icon, label }) => (
            <div key={label} className="flex items-center gap-2.5 justify-center md:justify-start">
              <Icon className="w-5 h-5 text-[hsl(var(--secondary))] shrink-0" />
              <span className="text-xs sm:text-sm font-semibold text-background/90">{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="container-mc py-14 grid grid-cols-1 md:grid-cols-12 gap-10 relative">
        <div className="md:col-span-5">
          <div className="mb-5">
            <BrandLogo light />
          </div>
          <p className="text-sm italic text-[hsl(var(--secondary))] mt-4 mb-3">{t("brand.tagline", "Talents de Guinée, opportunités pour tous")}</p>
          <p className="text-sm text-background/60 max-w-md leading-relaxed" data-testid="footer-tagline">
            {t("footer.tagline", "La plateforme de mise en relation entre clients et artistes guinéens. Conçu en Guinée 🇬🇳 pour la Guinée — Du Fouta au Forestier, de Conakry à Kankan.")}
          </p>
          <p className="text-xs text-background/40 mt-4" data-testid="footer-agency">
            {t("footer.agency", "Plateforme éditée par l'agence MCZ EVENTS")}
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[hsl(var(--secondary))] mb-4">Plateforme</p>
          <ul className="space-y-2.5 text-sm text-background/60">
            <li><a href="/explore" className="hover:text-background transition-colors duration-200">Explorer les artistes</a></li>
            <li><a href="/events" className="hover:text-background transition-colors duration-200">Billetterie</a></li>
            <li><a href="/register" className="hover:text-background transition-colors duration-200">Inscription artistes</a></li>
            <li><a href="/#how" className="hover:text-background transition-colors duration-200">Comment ça marche</a></li>
          </ul>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[hsl(var(--secondary))] mb-4 mt-8">Informations légales</p>
          <ul className="space-y-2.5 text-sm text-background/60" data-testid="footer-legal-links">
            <li><Link to="/legal/mentions-legales" data-testid="footer-link-mentions" className="hover:text-background transition-colors duration-200">Informations légales</Link></li>
            <li><Link to="/legal/conditions-utilisation" data-testid="footer-link-cgu" className="hover:text-background transition-colors duration-200">Conditions d'utilisation</Link></li>
            <li><Link to="/legal/conditions-vente" data-testid="footer-link-cgv" className="hover:text-background transition-colors duration-200">Conditions de vente</Link></li>
            <li><Link to="/legal/confidentialite" data-testid="footer-link-privacy" className="hover:text-background transition-colors duration-200">Politique de confidentialité</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[hsl(var(--secondary))] mb-4">{t("footer.security_label", "Sécurité & paiement")}</p>
          <p className="text-xs text-background/60 leading-relaxed">
            {t("footer.security_text", "Identité vérifiée pour chaque inscription. Paiements Mobile Money sécurisés. Tous les contrats sont protégés par MCZ EVENTS.")}
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-mc py-5 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs font-mono text-background/50 tracking-wider" data-testid="footer-copyright">
            {t("footer.copyright", "© {year} MCZ EVENTS · TOUS DROITS RÉSERVÉS").replace("{year}", String(year))}
          </p>
          <p className="text-xs font-mono text-background/50 tracking-wider">{t("footer.city_line", "CONAKRY · GUINÉE")}</p>
        </div>
      </div>
    </footer>
  );
}
